export default __webpack_public_path__ + "static/HongKongsguardianofthegods-868e021f195ccbb660b945a2746f02e9.jpg";